import { createSlice } from "@reduxjs/toolkit";
import activateUserApi from "@custom/rtk-apis/user/activateUser";

const initialState = {
  status:"",
  result:{},
  message:"",
  loading:false,
  error:""
};

const activateUserSlice = createSlice({
  name: "activateUserSlice",
  initialState,
  reducers: {
    closeActivateUserListModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(activateUserApi.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(activateUserApi.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(activateUserApi.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default activateUserSlice.reducer;
export const { closeActivateUserListModal } = activateUserSlice.actions;
